import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DocumentIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 32 32" sx={{ height: '32px', width: '32px', ...sx }} {...props}>
      <path
        d="M28.1875 8.4375L21.625 6.5625L19.75 0H6.625C5.07169 0 3.8125 1.25919 3.8125 2.8125V29.1875C3.8125 30.7408 5.07169 32 6.625 32H25.375C26.9283 32 28.1875 30.7408 28.1875 29.1875V8.4375Z"
        fill="#2E89D3"
      />
      <path
        d="M28.1875 8.4375V29.1875C28.1875 30.7408 26.9283 32 25.375 32H16V0H19.75L21.625 6.5625L28.1875 8.4375Z"
        fill="#0072CE"
      />
      <path
        d="M28.1875 8.4375H21.625C20.5938 8.4375 19.75 7.59375 19.75 6.5625V0C19.9938 0 20.2375 0.09375 20.4062 0.281312L27.9062 7.78131C28.0938 7.95 28.1875 8.19375 28.1875 8.4375Z"
        fill="#2E89D3"
      />
      <path
        d="M21.625 15.0625H10.375C9.85681 15.0625 9.4375 14.6432 9.4375 14.125C9.4375 13.6068 9.85681 13.1875 10.375 13.1875H21.625C22.1432 13.1875 22.5625 13.6068 22.5625 14.125C22.5625 14.6432 22.1432 15.0625 21.625 15.0625Z"
        fill="#FFF5F5"
      />
      <path
        d="M21.625 18.8125H10.375C9.85681 18.8125 9.4375 18.3932 9.4375 17.875C9.4375 17.3568 9.85681 16.9375 10.375 16.9375H21.625C22.1432 16.9375 22.5625 17.3568 22.5625 17.875C22.5625 18.3932 22.1432 18.8125 21.625 18.8125Z"
        fill="#FFF5F5"
      />
      <path
        d="M17.875 22.5478H10.375C9.85681 22.5478 9.4375 22.1285 9.4375 21.6103C9.4375 21.0921 9.85681 20.6728 10.375 20.6728H17.875C18.3932 20.6728 18.8125 21.0921 18.8125 21.6103C18.8125 22.1285 18.3932 22.5478 17.875 22.5478Z"
        fill="#FFF5F5"
      />
      <path
        d="M16 22.5478H17.875C18.3932 22.5478 18.8125 22.1285 18.8125 21.6103C18.8125 21.0921 18.3932 20.6728 17.875 20.6728H16V22.5478Z"
        fill="#E3E7EA"
      />
      <path
        d="M16 18.8125H21.625C22.1432 18.8125 22.5625 18.3932 22.5625 17.875C22.5625 17.3568 22.1432 16.9375 21.625 16.9375H16V18.8125Z"
        fill="#E3E7EA"
      />
      <path
        d="M16 15.0625H21.625C22.1432 15.0625 22.5625 14.6432 22.5625 14.125C22.5625 13.6068 22.1432 13.1875 21.625 13.1875H16V15.0625Z"
        fill="#E3E7EA"
      />
    </SvgIcon>
  );
};

export default DocumentIcon;
